module.exports = __webpack_public_path__ + "img/logout.9a6b8d4d.svg";